import { createStore } from 'redux';
import selectorsReducer from './selectorsReducer';

const selectorsStore = createStore(selectorsReducer);

export default selectorsStore;
